<template>
  <section
    class="all-cases-view case-creation"
    id="phlebio-view"
    v-loading="loading"
  >
    <div class="container-sm">
      <div class="case-creation__card">
        <div class="case-creation__heading edit-view">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-patient-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">PHLEBIO ORDER INFORMATION</h3>
          </div>
        </div>
        <div class="case-creation__body pb-0">
          <div class="vue-data">
            <el-form :model="phlebioInformation">
              <el-row :gutter="15">
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Phlebio Order Id </label>
                      <el-input
                        class="el-input"
                        v-model="phlebioInformation.Phlebio_Order_id"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient First Name </label>
                      <el-input
                        class="el-input"
                        v-model="phlebioInformation.Patient_first_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient Last Name</label>
                      <el-input
                        v-model="phlebioInformation.Patient_last_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient Address</label>
                      <el-input
                        v-model="phlebioInformation.Patient_street_address"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient Zip </label>
                      <el-input
                        v-model="phlebioInformation.Patient_zip"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient State </label>
                      <el-input
                        v-model="phlebioInformation.Patient_state"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient City </label>
                      <el-input
                        v-model="phlebioInformation.Patient_city"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Patient Phone</label>
                      <el-input
                        v-model="phlebioInformation.Patient_phone_number"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Laboratory</label>
                      <el-input
                        v-model="phlebioInformation.Laboratory"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Facility</label>
                      <el-input
                        v-model="phlebioInformation.Client_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Facility Address</label>
                      <el-input
                        v-model="phlebioInformation.Client_street"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Facility Zip</label>
                      <el-input
                        v-model="phlebioInformation.Client_zip"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Facility State</label>
                      <el-input
                        v-model="phlebioInformation.Client_state"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Facility City</label>
                      <el-input
                        v-model="phlebioInformation.Client_city"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Physician First Name</label>
                      <el-input
                        v-model="phlebioInformation.Provider_first_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Physician Middle Name</label>
                      <el-input
                        v-model="phlebioInformation.Provider_middle_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Physician Last Name</label>
                      <el-input
                        v-model="phlebioInformation.Provider_last_name"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Ordering Physician NPI</label>
                      <el-input
                        v-model="phlebioInformation.Provider_NPI"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Created</label>
                      <el-date-picker
                        type="datetime"
                        v-model="phlebioInformation.created_at"
                        placeholder="MM-DD-YYYY HH:MM AM"
                        format="MM-DD-YYYY hh:mm A"
                        :disabled-date="disabledDate"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Updated</label>
                      <el-date-picker
                        type="datetime"
                        v-model="phlebioInformation.updated_at"
                        placeholder="MM-DD-YYYY HH:MM AM"
                        format="MM-DD-YYYY hh:mm A"
                        :disabled-date="disabledDate"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Priority</label>
                      <el-input
                        v-model="phlebioInformation.Priority"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Service Date</label>
                      <el-date-picker
                        type="datetime"
                        v-model="phlebioInformation.Service_date"
                        placeholder="MM-DD-YYYY HH:MM AM"
                        format="MM-DD-YYYY hh:mm A"
                        :disabled-date="disabledDate"
                      ></el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Service Address </label>
                      <el-input
                        v-model="phlebioInformation.Service_street_address"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Service Zip</label>
                      <el-input
                        v-model="phlebioInformation.Service_zip"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Service State</label>
                      <el-input
                        v-model="phlebioInformation.Service_state"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="5" :md="8" :sm="12" :xs="12">
                  <div class="case-creation__input">
                    <el-form-item>
                      <label for="text">Service City</label>
                      <el-input
                        v-model="phlebioInformation.Service_city"
                      ></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
      <div class="case-creation__actions">
        <ul class="list">
          <li>
            <el-button
              type="default"
              class="btn cancel-button"
              @click="cancelUpdate()"
              >Cancel</el-button
            >
          </li>
          <li>
            <el-button
              type="success"
              class="btn save-button"
              @click="updatePhlebioOrder()"
              >Update</el-button
            >
          </li>
          <li
            v-if="
              getSinglePhlebioDetails &&
              (getSinglePhlebioDetails.Status == 'Completed' ||
                getSinglePhlebioDetails.Status == 'Performed' ||
                getSinglePhlebioDetails.Status == 'Delivered to Lab' ||
                getSinglePhlebioDetails.Status == 'Deliverd to Lab' || 
                getSinglePhlebioDetails.Status == 'Partial Accession')
            "
          >
            <el-button
              type="success"
              class="btn save-button"
              @click="convertPhlebioOrder()"
              >Create Accession</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      loading: false,
      phlebioInformation: {},
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
    };
  },
  computed: {
    ...mapGetters("phlebio", [
      "getSinglePhlebioDetails",
      "getUpdatePhlebioStatus",
      "getCaseData",
    ]),
  },
  async mounted() {
    if (this.$route.params.phlebio_id) {
      await this.fetchPhlebioOrderDetails();
    }
  },
  methods: {
    async updatePhlebioOrder() {
      try {
        this.loading = true;
        let params = this.phlebioInformation;
        params.phlebio_id = this.$route.params.phlebio_id;
        if (this.phlebioInformation && this.phlebioInformation.created_at) {
          params.created_at = this.convertToLabUTC(
            this.phlebioInformation.created_at
          );
        }
        if (this.phlebioInformation && this.phlebioInformation.updated_at) {
          params.updated_at = this.convertToLabUTC(
            this.phlebioInformation.updated_at
          );
        }
        if (this.phlebioInformation && this.phlebioInformation.Service_date) {
          params.Service_date = this.convertToLabUTC(
            this.phlebioInformation.Service_date
          );
        }
        await this.$store.dispatch("phlebio/updatePhlebio", params);
        if (this.getUpdatePhlebioStatus) {
          successNotification("Order updated successfully");
          this.cancelUpdate();
        } else {
          errorNotification("Error while updating order");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    cancelUpdate() {
      this.$router.go(-1);
    },
    async fetchPhlebioOrderDetails() {
      try {
        this.loading = true;
        let params = {
          phlebio_id: this.$route.params.phlebio_id,
        };
        await this.$store.dispatch("phlebio/phlebioDetails", params);
        if (this.getSinglePhlebioDetails) {
          this.phlebioInformation.Patient_first_name =
            this.getSinglePhlebioDetails.Patient_first_name;
          this.phlebioInformation.Patient_last_name =
            this.getSinglePhlebioDetails.Patient_last_name;
          this.phlebioInformation.Patient_street_address =
            this.getSinglePhlebioDetails.Patient_street_address;
          this.phlebioInformation.Patient_zip =
            this.getSinglePhlebioDetails.Patient_zip;
          this.phlebioInformation.Patient_city =
            this.getSinglePhlebioDetails.Patient_city;
          this.phlebioInformation.Patient_state =
            this.getSinglePhlebioDetails.Patient_state;
          this.phlebioInformation.Patient_phone_number =
            this.getSinglePhlebioDetails.Patient_phone_number;
          this.phlebioInformation.Laboratory =
            this.getSinglePhlebioDetails.Laboratory;
          this.phlebioInformation.Client_name =
            this.getSinglePhlebioDetails.Client_name;
          this.phlebioInformation.Client_street =
            this.getSinglePhlebioDetails.Client_street;
          this.phlebioInformation.Client_zip =
            this.getSinglePhlebioDetails.Client_zip;
          this.phlebioInformation.Client_city =
            this.getSinglePhlebioDetails.Client_city;
          this.phlebioInformation.Client_state =
            this.getSinglePhlebioDetails.Client_state;
          this.phlebioInformation.Provider_first_name =
            this.getSinglePhlebioDetails.Provider_first_name;
          this.phlebioInformation.Provider_last_name =
            this.getSinglePhlebioDetails.Provider_last_name;
          this.phlebioInformation.Provider_middle_name =
            this.getSinglePhlebioDetails.Provider_middle_name;
          this.phlebioInformation.Provider_NPI =
            this.getSinglePhlebioDetails.Provider_NPI;
          this.phlebioInformation.Priority =
            this.getSinglePhlebioDetails.Priority;
          this.phlebioInformation.Service_street_address =
            this.getSinglePhlebioDetails.Service_street_address;
          this.phlebioInformation.Service_zip =
            this.getSinglePhlebioDetails.Service_zip;
          this.phlebioInformation.Service_state =
            this.getSinglePhlebioDetails.Service_state;
          this.phlebioInformation.Service_city =
            this.getSinglePhlebioDetails.Service_city;
          this.phlebioInformation.created_at = this.convertLabUTCToClient(
            this.getSinglePhlebioDetails.created_at
          );
          this.phlebioInformation.updated_at = this.convertLabUTCToClient(
            this.getSinglePhlebioDetails.updated_at
          );
          this.phlebioInformation.Service_date = this.convertLabUTCToClient(
            this.getSinglePhlebioDetails.Service_date
          );
          this.phlebioInformation.Phlebio_Order_id =
            (this.getSinglePhlebioDetails &&
              this.getSinglePhlebioDetails.Phlebio_Order_id) ||
            "";
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    async convertPhlebioOrder() {
      this.loading = true;
      const phlebioId = this.$route.params.phlebio_id;
      let params = {
        phlebio_id: phlebioId,
      };
      await this.$store.dispatch("phlebio/prepareCaseData", params);
      if (this.getCaseData) {
        this.$store.dispatch("phlebio/setPhlebioInfo", this.getCaseData.data);
        this.$router.push({
          name: "Create-Accession",
          params: { phlebio_id: phlebioId },

          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      } else {
        errorNotification(this.getError || "Unable to fetch order data");
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
#phlebio-view {
  .case-creation__card {
    position: relative;
    .edit-btn {
      position: absolute;
      right: 0px;
      top: -3px;
      z-index: 99;
      padding: 0 20px;
      border: none;
      background-color: transparent;
      color: #828282;
      img {
        position: relative;
        top: 2.5px;
      }
    }
  }
  .case-creation__input .el-input__inner {
    font-size: 12px;
  }
}
</style>
